<template>
  <div class="order">
    <van-tabs
      v-model="tabValue"
      class="tab-wrap"
      color="#0070FF"
      title-active-color="#0070FF"
      @change="tabChange"
    >
      <van-tab v-for="(item, i) in tab" :key="i" :title="item.name"></van-tab>
    </van-tabs>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        class="list-wrap"
        v-if="listShow"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <orderList v-for="item in list" :key="item.id" :item="item"></orderList>
      </van-list>
      <van-empty
        v-if="!listShow"
        class="custom-image"
        :image="require('../../../../assets/coupons-none.png')"
        description="暂无数据"
      />
    </van-pull-refresh>
  </div>
</template>
<script>
import orderList from './orderList'
import { listByPage } from '@api/market/index'
import { Toast } from 'vant'
export default {
  components: {
    orderList
  },
  data() {
    return {
      tabValue: '',
      tabId: '',
      tab: [
        {
          id: '',
          name: '全部'
        },
        {
          id: 0,
          name: '待机构确认'
        },
        {
          id: 1,
          name: '待企业确认'
        },
        {
          id: 2,
          name: '待评价'
        },
        {
          id: 3,
          name: '已完成'
        },
        {
          id: 4,
          name: '已失效'
        }
      ],
      list: [],
      listShow: true,
      loading: true,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      isLoading: false
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === '/market/index') {
        this.getList(1)
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList(num) {
      if (num) {
        this.pageNum = 1
        this.list = []
        this.loading = true
        this.finished = false
        this.listShow = true
      }
      const params = {
        orderStatus: this.tabId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      listByPage(params).then(res => {
        const { code, data, msg } = res.data
        if (code === '0000') {
          data.results.forEach(item => {
            let statusText = ''
            let btnText = ''
            let arr
            switch (item.orderStatus) {
              case 0:
                statusText = '待机构确认'
                break
              case 1:
                statusText = '待企业确认'
                btnText = '确认订单'
                break
              case 2:
                statusText = '待评价'
                btnText = '评价'
                break
              case 3:
                statusText = '已完成'
                btnText = '查看评价'
                break
              case 4:
                statusText = '已失效'
                break
            }
            arr = {
              ...item,
              statusText: statusText,
              btnText: btnText
            }
            this.list.push(arr)
          })
          this.loading = false
          this.isLoading = false
          if (data.results.length < this.pageSize) {
            this.finished = true
          } else {
            this.finished = false
          }
          if (this.list.length == 0) {
            this.listShow = false
          } else {
            this.listShow = true
          }
        } else {
          Toast(msg)
        }
      })
    },
    onLoad() {
      this.pageNum++
      this.getList()
    },
    tabChange(e) {
      this.tabId = this.tab[e].id
      this.getList(1)
    },
    onRefresh() {
      this.getList(1)
    }
  }
}
</script>
<style lang="scss" scoped>
.order {
  width: 100%;
  min-height: 100vh;
  background: #f7f7f7;
  padding-bottom: 50px;
  box-sizing: border-box;
}
.custom-image {
  margin-top: 30%;
  /deep/.van-empty__image {
    width: 200px;
    height: 120px;
  }
  /deep/.van-empty__description {
    margin-top: -36px;
  }
}
</style>
